module.exports = __webpack_public_path__ + "static/media/shouvik-mukherjee.d0ec61d0.jpg";